import { FormlyFieldConfig } from '@ngx-formly/core';
import { DetailsFormOptions } from './details-form-options.interface';
import { toFormlyOptions, isRapidProgram } from './details-form-helpers';

/**
 * SECTION 2.1: CLIENT PREQUALIFYING QUESTIONS
 */
export function getClientPrequalifyingFields(options: DetailsFormOptions): FormlyFieldConfig[] {
  return [
    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Residency_Status',
          type: 'select',
          props: {
            label: 'Residency Status',
            options: toFormlyOptions(options.residencyStatuses$),
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Employment_Status',
          type: 'select',
          props: {
            label: 'Employment Type',
            options: toFormlyOptions(options.employmentStatuses$),
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Do_you_earn_at_least_1200_per_month',
          type: 'select',
          props: {
            label: 'Do you earn at least $1200 per month',
            options: [
              { value: 'Yes', label: 'Yes' },
              { value: 'No', label: 'No' },
            ],
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Payday_loans',
          type: 'select',
          props: {
            label: 'Do you have any Active Payday loans?',
            options: [
              { value: 'Yes', label: 'Yes' },
              { value: 'No', label: 'No' },
            ],
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Employed',
          type: 'select',
          props: {
            label: 'Are you currently employed (Completed probation)',
            options: [
              { value: 'Yes', label: 'Yes' },
              { value: 'No', label: 'No' },
            ],
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Are_you_currently_a_Home_Owner',
          type: 'select',
          props: {
            label: 'Are you currently a Home Owner',
            options: [
              { value: 'Yes', label: 'Yes' },
              { value: 'No', label: 'No' },
            ],
          },
          expressions: {
            'props.required': (field: FormlyFieldConfig) => isRapidProgram(field),
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Province1',
          type: 'select',
          props: {
            label: 'Province',
            options: toFormlyOptions(options.provinces$),
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'How_much_do_you_currently_owe_the_CRA',
          type: 'select',
          props: {
            label: 'How much do you currently owe the CRA',
            options: [
              { value: '$0', label: '$0' },
              { value: 'Below $1,000', label: 'Below $1,000' },
              { value: '$1,000-$2,500', label: '$1,000-$2,500' },
              { value: '$2,500-$5,000', label: '$2,500-$5,000' },
              { value: '$5,000-$10,000', label: '$5,000-$10,000' },
              { value: '$10,000+', label: '$10,000+' },
            ],
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'If_needed_could_you_find_a_Co_Singer',
          type: 'select',
          props: {
            label: 'If needed could you find a Co-Signer',
            options: [
              { value: 'Yes', label: 'Yes' },
              { value: 'No', label: 'No' },
            ],
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'native_reserve',
          type: 'select',
          props: {
            label: 'Is this address on a native reserve?',
            options: [
              { value: 'Yes', label: 'Yes' },
              { value: 'No', label: 'No' },
            ],
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Bankruptcy_CC_CP',
          type: 'select',
          props: {
            label: 'Bankruptcy, Credit Counselling, Consumer Proposal',
            options: toFormlyOptions(options.bankruptcyOptions$),
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Consent_Form_Signed',
          type: 'select',
          props: {
            label: 'Do you have a LM Credit loan?',
            options: [
              { value: 'Yes', label: 'Yes' },
              { value: 'No', label: 'No' },
            ],
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Payment_Method',
          type: 'select',
          props: {
            label: 'How do you get paid? (Payment Method)',
            options: toFormlyOptions(options.paymentMethods$),
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Is_this_a_staffing_agency',
          type: 'select',
          props: {
            label: 'Is this a staffing agency?',
            options: [
              { value: 'Yes', label: 'Yes' },
              { value: 'No', label: 'No' },
            ],
          },
        },
        {
          expressions: {
            hide: (field: FormlyFieldConfig) => field.model?.Are_you_currently_a_Home_Owner !== 'Yes',
          },
          fieldGroupClassName: 'row',
          fieldGroup: [
            {
              type: 'section-header',
              props: {
                label: 'Existing mortgage',
              },
            },
            {
              className: 'col-sm-6 col-lg-4',
              key: 'MTG_Balance',
              type: 'currency',
              props: {
                label: 'Mortgage Balance',
              },
            },
            {
              className: 'col-sm-6 col-lg-4',
              key: 'Estimated_Value',
              type: 'currency',
              props: {
                label: 'Home Property Value',
              },
            },
            {
              className: 'col-sm-6 col-lg-4',
              key: 'Loan_Det',
              type: 'input',
              props: {
                label: 'Loan Details',
              },
            },
            {
              className: 'col-sm-6 col-lg-4',
              key: 'Mortgage_Details',
              type: 'input',
              props: {
                label: 'Mortgage Details',
              },
            },
          ],
        },
      ],
    },
  ];
}